module.exports = __webpack_public_path__ + "./data/projects/entities.json";


//////////////////
// WEBPACK FOOTER
// ./~/entities/maps/entities.json
// module id = 107
// module chunks = 0